import Layout from "@/components/Layout";
import ComingSoon from "@/components/ComingSoon";

const API = () => {
  return (
    <Layout
      seoTitle="API - Coming Soon - SKECHA"
      seoDescription="SKECHA API is coming soon. Integrate AI-powered coloring page generation into your own applications and services."
      seoKeywords="API, developer tools, integration, coloring page API, SKECHA API"
      seoUrl="https://skecha.com/api"
    >
      <ComingSoon />
    </Layout>
  );
};

export default API;